/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */

import type { Action, AnyAction } from "redux";
import { combineReducers } from "redux";
import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import type { ThunkAction, ThunkDispatch } from "redux-thunk";

import userSlice from "./users/slice";
import gameSlice from "./game/slice";
import { configureStore } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  user: userSlice,
  game: gameSlice
});

export type AppState = ReturnType<typeof rootReducer>;
export const useTypedSelector: TypedUseSelectorHook<AppState> = useSelector;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;

export type TypedDispatch = ThunkDispatch<any, any, AnyAction>;

export const useTypedDispatch = () => useDispatch<TypedDispatch>();

export default configureStore({
  reducer: rootReducer
});

// export default function configureStore() {
//   const middlewares = [thunkMiddleware]

//   const middleWareEnhancer = applyMiddleware(...middlewares)

//   const store = createStore(
//     rootReducer,
//     middleWareEnhancer,
//   )

//   return store
// }
